import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "field",
  id: "search"
}
const _hoisted_2 = { class: "tabs is-small" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "tabs is-small" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "control" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = {
  key: 0,
  class: "progress is-small is-info"
}
const _hoisted_9 = {
  key: 1,
  id: "results"
}
const _hoisted_10 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cropper = _resolveComponent("Cropper")!
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiNames, (api) => {
            return (_openBlock(), _createElementBlock("li", {
              key: api,
              class: _normalizeClass({'is-active': _ctx.currentApi === api})
            }, [
              _createElementVNode("a", {
                class: "first-capitalized",
                href: "#",
                onClick: _withModifiers(($event: any) => (_ctx.changeApi(api)), ["prevent"])
              }, _toDisplayString(api), 9, _hoisted_3)
            ], 2))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
            return (_openBlock(), _createElementBlock("li", {
              key: tab,
              class: _normalizeClass({'is-active': _ctx.currentTab === tab})
            }, [
              _createElementVNode("a", {
                class: "first-capitalized",
                href: "#",
                onClick: _withModifiers(($event: any) => (_ctx.changeTab(tab)), ["prevent"])
              }, _toDisplayString(tab), 9, _hoisted_5)
            ], 2))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          class: "input",
          placeholder: 'Search ' + _ctx.currentTab + ' or drag and drop images here',
          autocomplete: "off",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
          type: "text",
          id: "name",
          name: "name",
          onDragenter: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
          onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
          onDrop: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"]))
        }, null, 40, _hoisted_7), [
          [_vModelText, _ctx.query]
        ])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("progress", _hoisted_8))
      : (_ctx.results.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (result) => {
              return (_openBlock(), _createBlock(_component_Cropper, {
                onSelected: ($event: any) => (_ctx.selected = result),
                key: result.mal_id,
                result: result
              }, null, 8, ["onSelected", "result"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("a", {
      href: "#",
      onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)), ["prevent"]))
    }, [
      _createVNode(_component_ion_icon, {
        size: "large",
        name: "arrow-undo-outline"
      })
    ], 512), [
      [_vShow, _ctx.showing_more]
    ]),
    (!_ctx.has_show_more && _ctx.selected)
      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.selected.title), 1))
      : (!_ctx.showing_more && _ctx.selected)
        ? (_openBlock(), _createElementBlock("a", {
            key: 3,
            href: "#",
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.showMore(_ctx.currentTab)), ["prevent"]))
          }, [
            _cache[6] || (_cache[6] = _createTextVNode("Show more of ")),
            _createElementVNode("b", null, _toDisplayString(_ctx.selected.title), 1)
          ]))
        : _createCommentVNode("", true)
  ], 64))
}